import { latLngBounds } from 'leaflet'
export default {
    computed: {
        bounds() {
            return latLngBounds([[18.50, -79], [17.9, -76]])
        },
        maxBounds() {
            return latLngBounds([[18.50, -79], [17.9, -76]])
        },
        countryCode(){
            return "JM"
        }
    },
}
